import { Injectable } from '@angular/core';

@Injectable()
export class DomainService {
  constructor() {}
  /**
   * Checks if is shopping domain.
   * @return {boolean} True if the domain from shopping.
   */
  isShoppingDomain(): boolean {
    const domain = window.location.hostname;
    return domain.indexOf('redes.') === -1;
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/domain/domain.service.ts